import { createActions } from 'redux-actions';

const { common } = createActions({
  COMMON: {
    TOGGLE_DRAWER: opened => ({ opened }),
  },
});

export default common;
